module.exports = __webpack_public_path__ + "static/BigBang_Mega-4c115414f88e280d4df194656e02f76e.mp4";